import { handleOfficeError } from '@utils-global';
import {
  EwsResponseError,
  getEWSRequestBodyTemplate,
  getMoveMailBodyTemplate,
  isEwsResponseFault,
  parseResponse,
  parseResponseAttribute,
  parseXml,
  withEwsRetry,
  type EwsActionResult,
} from './helpers';

/** DistinguishedFolderId, culture-invariant on every mailbox. */
const DELETED_ITEMS_FOLDER_ID = 'deleteditems';

const OPERATION = 'EWS delete';

export const deleteMail = (
  mailId: string,
  isSharedMailbox: boolean = false,
): Promise<EwsActionResult> =>
  withEwsRetry(
    () =>
      new Promise<EwsActionResult>((resolve, reject) => {
        const requestBody = getEWSRequestBodyTemplate(
          getMoveMailBodyTemplate(DELETED_ITEMS_FOLDER_ID, mailId),
        );
        Office.context.mailbox.makeEwsRequestAsync(requestBody, (result) => {
          if (result.status === Office.AsyncResultStatus.Failed) {
            reject(handleOfficeError(result.error, { operation: OPERATION, isSharedMailbox }));
            return;
          }

          const doc = parseXml(result.value);
          const [responseCode, messageText] = parseResponse(doc, ['ResponseCode', 'MessageText']);

          if (isEwsResponseFault(responseCode)) {
            reject(
              new EwsResponseError(
                OPERATION,
                responseCode,
                messageText ?? undefined,
                DELETED_ITEMS_FOLDER_ID,
              ),
            );
            return;
          }

          resolve({
            movedMailId: parseResponseAttribute(doc, 'ItemId', 'Id'),
          });
        });
      }),
  );
